import React, { useState, useEffect, Fragment } from "react";
import avatar1Img from "../../images/newHome/avatar-1.png"
import avatar2Img from "../../images/newHome/avatar-2.png"
import ThemeButton from "./ThemeButton";
import { Link } from "react-router-dom";

function GetInTouchSection() {
    const avatarImages = [
        {
            src: avatar1Img,
            alt: 'User 1'
        },
        {
            src: null,
            alt: 'Center'
        },
        {
            src: avatar2Img,
            alt: 'User 2'
        }
    ]
    return (
        <Fragment>
            <div className="container">
                <div className="rounded-xl lg:py-16 lg:px-8 p-5 md:mb-24 mb-10 bg-lightGrayBgColor">
                    {/* images */}
                    <div className="flex justify-center items-center space-x-[-20px]">
                        {avatarImages.map((avtar, index) => (
                            avtar.src ? (
                                <img
                                    key={index}
                                    src={avtar.src}
                                    alt={avtar.alt}
                                    className={`${avtar.alt === 'Center' ? 'z-20 -mt-3' : 'z-10'} w-14 rounded-full border-2 border-white`}
                                />
                            ) : (
                                <div
                                    key={index}
                                    className="w-14 h-14 rounded-full border-2 border-white bg-[#E0E0E0] -mt-3 z-20"
                                />
                            )
                        ))}
                    </div>
                    <div className="max-w-3xl mx-auto md:mt-8 mt-5 text-center">
                        <p className="font-medium text-xl">Still have questions ?</p>
                        <p className="text-lg text-grayTextColor mt-2">Can’t find the answer you’re looking for? Please chat to our friendly team.</p>
                        <Link
                            to="/contact-us"
                            className={`ttnc-logo inline-block`}
                        >
                            <ThemeButton
                                bgColor="bg-primaryColor"
                                textColor="text-white"
                                padding="py-4 px-[22px] mt-8"
                                size="font-medium"
                            >
                                Get in Touch
                            </ThemeButton>
                        </Link>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}
export default GetInTouchSection;